var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoorOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 43V5H37V43H11Z",
    fill: "#8D6E63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 43V5H37L11 43Z",
    fill: "#6D4C41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 43V5L26 3V45L11 43Z",
    fill: "#EE8003"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 21V27C23 27.6 22.6 28 22 28C21.4 28 21 27.6 21 27V21C21 20.4 21.4 20 22 20C22.6 20 23 20.4 23 21Z",
    fill: "#BF360C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorOpen);
export default __webpack_public_path__ + "static/media/door-open.fa4c2c40535d7467d9bc951788ed3b5c.svg";
export { ForwardRef as ReactComponent };